import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkChangeoverSettingModel extends Model {
  @attr('boolean') enabled!: boolean;

  @hasMany('changeover-setting', { inverse: null, async: false })
  changeoverSettings!: ModelRegistry['changeover-setting'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-changeover-setting': BulkChangeoverSettingModel;
  }
}
